import React, { Component } from 'react';
import Box from 'grommet/components/Box';
import { connect } from 'react-redux';
import Article from 'grommet/components/Article';
import Heading from 'grommet/components/Heading';
import FormField from 'grommet/components/FormField';
import TextInput from 'grommet/components/TextInput';
import Select from 'grommet/components/Select';
import CircleInformationIcon from 'grommet/components/icons/base/CircleInformation';
import Layer from 'grommet/components/Layer';
import CloseIcon from 'grommet/components/icons/base/FormClose';
import { toggleSizeButton } from '../../State/actions/sessions';
import { fetchgatewaydlts, fetchDefaults, getosdisklistBlueData, controllerchnaged, getTenantStorageDiskList, GetControllerRecommendations, GetMasterRecommendations } from '../Redux/actions/epaActions';
import { CHANGE_GATEWAY } from '../Redux/action_types/epaActionTypes';
import Paragraph from 'grommet/components/Paragraph';
import Spinning from 'grommet/components/icons/Spinning';
import ReactTooltip from 'react-tooltip';
//import CheckBox from 'grommet/components/CheckBox';
import Tabs from 'grommet/components/Tabs';
import Tab from 'grommet/components/Tab';
import CheckBox from 'grommet/components/CheckBox';
import * as Constants from '../Redux/action_types/EPAConstants.js';
import { validateApollo4200SFFDrives, validateNVMEorSFFDrivesCount, validateDriveChange, updateControllerHostCount, updateMasterHostCount, updateFinishButton, filterOptions } from '../commonLogic.js';
import Warning from './Warning';
//let gatewayhostcount = 0;
//let controllerhostcount = 0;
let HostChanged = false;
let selectchange = "";
let Gatewaylist = '';
let Controllerlist = '';
let Masterlist = '';
let GatewayHostType, GatewayHostlist, GatewayCPUtype, GatewayCPUFamilytype, GatewayMemory, GatewayMemoryList, GatewayOSDrive, GatewayOSDriveList, GatewayStrDrvtype, GatewayStrDrvList, GatewayStrDrvCount, GatewayCount, HAIncluded;
let GatewayCPUList = [];
let GatewayCPUFamilyList = [];
let ControllerHostType, ControllerHostlist, ControllerCPUtype, ControllerCPUFamilytype, ControllerCPUList, ControllerCPUFamilyList, ControllerMemory, ControllerMemoryList, ControllerOSDrive, ControllerOSDriveList, ControllerStrDrvtype, ControllerStrDrvList, TenantStrDrvtypelist, ControllerStrDrvCount, ControllerCount;
let MasterHostType, MasterHostlist, MasterCPUtype, MasterCPUFamilytype, MasterCPUList, MasterCPUFamilyList, MasterMemory, MasterMemoryList, MasterOSDrive, MasterOSDriveList, MasterStrDrvtype, MasterStrDrvList, MasterTenantStrDrvtypelist, MasterStrDrvCount, MasterCount;
let TenantStrDrvtype, TenantStrDrvQty, MasterTenantStrDrvtype, MasterTenantStrDrvQty;
let MaxDrives = '';
let NVMEMaxDrives = "";
let ControllerMaxDrives = '';
let ControllerNVMEMaxDrives = "";
let MasterMaxDrives = '';
let MasterNVMEMaxDrives = "";
var GatewayDatadriveChanged = false;
var ControllerDatadriveChanged = false;
var MasterDatadriveChanged = false;

const NVMESTRING = "NVME";
let warningText = "";
class DesignRequirements extends Component {
    constructor() {
        super();
        this.state = {
            currentTabActiveIndex: 2,

        };


    }

    componentDidMount() {
        if (updateFinishButton(this.props.workload, this.props.displayWarning, this.props.activeSession.isSizeEnabled)) {
            this.props.OnToggleSizeButton(true);
        }
    }
    layerclose() {
        // Minlayer = false
        HostChanged = false
        this.setState({})
    }
    GPUChange(e, textinput) {
        selectchange = e.value
        if (textinput === "GatewayHostType" || textinput === "ControllerHostType" || textinput === "MasterHostType") {
            if (textinput === "GatewayHostType") {
                if (GatewayHostType !== selectchange)
                    HostChanged = true

            } else {
                if (ControllerHostType !== selectchange || MasterHostType !== selectchange) {
                    HostChanged = true
                    if (this.props.workload.UserInputs.Environments.VMWareUserChoice === "true" && textinput === "ControllerHostType") {
                        const configMode = this.props.workload.UserInputs.Environments.Environment.find(solution => solution["@isCurrentTab"] === Constants.yES_).Templates.ServerDetails.Requirements["@ConfigBasedOn"];
                        const controllerServer = e.value;
                        const controllerPayload = {
                            "strServer": controllerServer,
                            "strHostType": Constants.CONTROLLER_HOST,
                            "strConfigMode": configMode,
                            "isControllerHostVMWareChecked": this.props.workload.UserInputs.Environments.VMWareUserChoice
                        }
                        this.props.ControllerRecommendations(controllerPayload);
                        this.props.ServiceError.guiState.GandCAPICount = 1;
                        this.props.ServiceError.guiState.updateManagementDetails = false;

                        //this.setState({});
                    }

                    if (this.props.workload.UserInputs.Environments.MasterVMWareUserChoice === "true" && textinput === "MasterHostType") {
                        const configMode = this.props.workload.UserInputs.Environments.Environment.find(solution => solution["@isCurrentTab"] === Constants.yES_).Templates.ServerDetails.Requirements["@ConfigBasedOn"];
                        const masterServer = e.value;
                        const masterPayload = {
                            "strServer": masterServer,
                            "strHostType": Constants.MASTER_HOST,
                            "strConfigMode": configMode,
                            "isControllerHostVMWareChecked": this.props.workload.UserInputs.Environments.MasterVMWareUserChoice
                        }
                        this.props.MasterRecommendations(masterPayload);
                        this.props.ServiceError.guiState.GandCAPICount = 1;
                        this.props.ServiceError.guiState.updateManagementDetails = false;

                        //this.setState({});
                    }
                }
            }
        }
        if (textinput === 'GatewayStrDrvtype') {
            if (GatewayStrDrvtype !== selectchange) { GatewayDatadriveChanged = true; }

        }
        else if (textinput === 'ControllerStrDrvtype') {
            if (ControllerStrDrvtype !== selectchange) { ControllerDatadriveChanged = true; }

        }
        else if (textinput === 'MasterStrDrvtype') {
            if (MasterStrDrvtype !== selectchange) { MasterDatadriveChanged = true; }

        }
        this.onWrkUpdateselect(selectchange, textinput)
    }
    ChkboxChange(e) {

        if (HAIncluded) {
            HAIncluded = false
            selectchange = "false"
        } else {
            HAIncluded = true
            selectchange = "true"
        }

        let textinput = "HAIncluded"
        this.onWrkUpdateselect(selectchange, textinput)
    }
    GPUtextchange(e, textinput, chorBlr) {
        var number = /^[0-9]+$/
        let minval = 1
        if (textinput === Constants.GATEWAY_NODE_STORAGE_DRIVE_COUNT || textinput === Constants.CONTROLLER_NODE_STORAGE_DRIVE_COUNT || (textinput === Constants.CONTROLLER_TENANT_DRIVE_COUNT && parseInt(this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_)["@TStorageDriveQty"], 10) == 0)) {
            minval = 0
        }
        if (chorBlr === Constants.CHANGE) {
            if (e.target.value.length < 3) {
                var value = parseInt(e.target.value, 10);
                if (isNaN(value)) {
                    selectchange = "";
                }
                else if ((number.test(value)) && (value <= 99) && (value >= minval) || isNaN(value)) {
                    selectchange = value.toString();
                }
                else {
                    selectchange = '1'
                }
            }
        } else {
            if (e.target.value === "") {
                selectchange = "1"
            } else {
                selectchange = e.target.value
            }
        }
        this.onWrkUpdateselect(selectchange, textinput)
    }
    onWrkUpdateselect = (value, textinput, chorBlr) => {
        var controllerdatadisk = value
        var masterdatadisk = value
        var gatewaydatadisk = value
        var isValidDriveCombination = true
        this.props.workload.UserInputs.Environments.ManagementHosts.Server.filter((x) => {
            let selectedDriveValidation = (drive1, drive2, maxDrives, serverName) => {
                if (x["@Name"] === Constants.HPE_APOLLO_4200_GEN10 && (value.toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1 || value.toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) > -1)) {
                    isValidDriveCombination = validateApollo4200SFFDrives(drive1, drive2, value);
                }
                if (isValidDriveCombination) {
                    isValidDriveCombination = validateDriveChange(drive1, drive2, value, serverName);
                }
                if (!isValidDriveCombination) {
                    warningText = this.renderErrorPopup(Constants.DRIVE_CANNOTBE_MIXED, Constants.ERROR_TEXT);
                }
                if (isValidDriveCombination) {
                    isValidDriveCombination = validateNVMEorSFFDrivesCount(x, maxDrives);
                    if (!isValidDriveCombination) {
                        warningText = this.renderErrorPopup(Constants.MAXDRIVEQTY_EXCEEDED[0] + maxDrives + Constants.MAXDRIVEQTY_EXCEEDED[1], Constants.ERROR_TEXT)
                    }
                }
            }
            switch (x["@Type"]) {

                case "Gateway":
                    if (textinput === "GatewayHostType") {
                        if (GatewayHostType !== value) {
                            x["@Name"] = value;
                            if (x["@Name"].indexOf(Constants.MOONSHOT_510) === -1 && x['@Name'].indexOf(Constants.E910) === -1 && x['@Name'].indexOf(Constants.MOONSHOT_750) === -1) {
                                x["@ServerName"] = x["@Name"]
                                x["@ProcQty"] = "2"
                            }
                            else {
                                x["@ServerName"] = "HP Moonshot System"
                                x["@ProcQty"] = "1"
                            }
                            x["@OSDiskQty"] = x["@Name"].indexOf(Constants.MOONSHOT_510) > -1 ? "1" : "2";
                            GatewayCPUList = []
                            GatewayCPUFamilyList = []
                            GatewayMemoryList = []
                            GatewayOSDriveList = []
                            GatewayStrDrvList = []
                            for (let key in Gatewaylist) {
                                if (key === x["@Name"]) {
                                    MaxDrives = Gatewaylist[key].MaxDrives;
                                    NVMEMaxDrives = Gatewaylist[key].MaxNVMeDrives
                                    GatewayStrDrvList = Gatewaylist[key].DataDriveList
                                    if (GatewayStrDrvList.indexOf(x["@NodeDisk"]) === -1) {
                                        x["@NodeDisk"] = GatewayStrDrvList[0]
                                    }
                                    GatewayOSDriveList = Gatewaylist[key].OSDriveList
                                    if (GatewayOSDriveList.indexOf(x["@OSDisk"]) === -1) {
                                        x["@OSDisk"] = GatewayOSDriveList[0]
                                    }
                                    for (let proctype in Gatewaylist[x["@Name"]].ProcessorList) {
                                        GatewayCPUFamilyList.push(proctype)
                                    }
                                    if (GatewayCPUFamilyList.indexOf(x["@ProcFamily"]) === -1) {
                                        x["@ProcFamily"] = GatewayCPUFamilyList[0]
                                    }
                                    for (let proctype in Gatewaylist[x["@Name"]].ProcessorList) {
                                        if (proctype === x["@ProcFamily"]) {
                                            for (let proc in Gatewaylist[x["@Name"]].ProcessorList[proctype]) {
                                                GatewayCPUList.push(proc)
                                            }
                                            if (GatewayCPUList.indexOf(x["@Proc"]) === -1) {
                                                x["@Proc"] = GatewayCPUList[0]
                                            }
                                            GatewayMemoryList = Gatewaylist[x["@Name"]].ProcessorList[proctype][x["@Proc"]]
                                            if (GatewayMemoryList.indexOf(x["@Memory"]) === -1) {
                                                x["@Memory"] = GatewayMemoryList[0]
                                            }
                                        }
                                    }

                                }

                            }
                            x["@StorageDiskQty"] = "0";
                        }
                    }


                    if (textinput === "GatewayCPUtype") {
                        x["@Proc"] = value;
                    }
                    if (textinput === "GatewayCPUFamilytype") {
                        x["@ProcFamily"] = value;
                        GatewayMemoryList = []
                        GatewayCPUList = []
                        for (let key in Gatewaylist) {
                            if (key === x["@Name"]) {
                                for (let procfamily in Gatewaylist[key].ProcessorList) {
                                    if (procfamily === x["@ProcFamily"]) {
                                        for (let proc in Gatewaylist[key].ProcessorList[procfamily]) {
                                            GatewayCPUList.push(proc)
                                        }
                                        x["@Proc"] = GatewayCPUList[0]
                                        GatewayMemoryList = Gatewaylist[x["@Name"]].ProcessorList[procfamily][x["@Proc"]]
                                        if (GatewayMemoryList.indexOf(x["@Memory"]) === -1) {
                                            x["@Memory"] = GatewayMemoryList[0]
                                        }
                                    }
                                }

                            }

                        }
                    }

                    if (textinput === Constants.GATEWAY_NODE_STORAGE_DRIVE) {
                        if (GatewayStrDrvtype !== value) {
                            let oldDrive = GatewayStrDrvtype;
                            x["@NodeDisk"] = value;
                            selectedDriveValidation(x["@TStorageDrive"], x["@OSDisk"], this.props.gatewaydetails[x["@Name"]].MaxNVMeDrives, x["@Name"]);
                            if (!isValidDriveCombination) {
                                x["@NodeDisk"] = oldDrive;
                            }
                            GatewayStrDrvtype = x["@NodeDisk"];
                            GatewayDatadriveChanged = false;
                        }
                    }


                    if (textinput === Constants.GATEWAY_OSDRIVE) {
                        if (GatewayOSDrive !== value) {
                            let oldDrive = GatewayOSDrive;
                            x["@OSDisk"] = value;
                            selectedDriveValidation(x["@TStorageDrive"], x["@NodeDisk"], this.props.gatewaydetails[x["@Name"]].MaxNVMeDrives, x["@Name"]);
                            if (!isValidDriveCombination) {
                                x["@OSDisk"] = oldDrive;
                            }
                            GatewayOSDrive = x["@OSDisk"];
                        }
                    }

                    if (textinput === "GatewayStrDrvCount") {

                        if (value && (x["@NodeDisk"].toUpperCase().indexOf(NVMESTRING) !== -1 || (x["@Name"] === Constants.HPE_APOLLO_4200_GEN10 && x["@NodeDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) > -1))) {
                            let qty = NVMEMaxDrives;
                            if (x["@OSDisk"].toUpperCase().indexOf(NVMESTRING) !== -1 || (x["@Name"] === Constants.HPE_APOLLO_4200_GEN10 && x["@OSDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) > -1)) {
                                qty -= parseInt(x['OSDiskQty'], 10);
                            }
                            if (parseInt(value, 10) < qty) {
                                x["@StorageDiskQty"] = value;
                            } else x["@StorageDiskQty"] = qty.toString();


                        }
                        else if ((MaxDrives - parseInt(x["@OSDiskQty"], 10)) < parseInt(value, 10) && x["@NodeDisk"].toUpperCase().indexOf(NVMESTRING) === -1) {
                            x["@StorageDiskQty"] = (MaxDrives - parseInt(x["@OSDiskQty"], 10)).toString()
                        } else {
                            x["@StorageDiskQty"] = value;
                        }

                    }


                    if (textinput === "GatewayCount") {
                        if (this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_)["@HAIncluded"] === "true") {
                            if (parseInt(value, 10) < 2) {
                                x["@NodesCount"] = "2"
                            } else {
                                x["@NodesCount"] = value;
                            }
                        }
                        else {
                            x["@NodesCount"] = value;
                        }
                    }

                    if (textinput === "GatewayMemory")
                        x["@Memory"] = value;

                    break;
                case "Controller":
                    if (textinput === "ControllerHostType") {
                        if (ControllerHostType !== value) {
                            x["@Name"] = value;
                            if (x["@Name"].indexOf(Constants.MOONSHOT_510) === -1 && x['@Name'].indexOf(Constants.E910) === -1 && x['@Name'].indexOf(Constants.MOONSHOT_750) === -1) {
                                x["@ServerName"] = x["@Name"]
                                x["@ProcQty"] = "2"
                            }
                            else {
                                x["@ServerName"] = "HP Moonshot System"
                                x["@ProcQty"] = "1"
                            }
                            x["@OSDiskQty"] = x["@Name"].indexOf(Constants.MOONSHOT_510) > -1 ? "1" : "2";
                            ControllerCPUList = []
                            ControllerMemoryList = []
                            ControllerOSDriveList = []
                            ControllerStrDrvList = []
                            TenantStrDrvtypelist = [];
                            ControllerCPUFamilyList = []
                            for (let key in Controllerlist) {
                                if (key === x["@Name"]) {
                                    ControllerMaxDrives = Controllerlist[key].MaxDrives;
                                    ControllerNVMEMaxDrives = Controllerlist[key].MaxNVMeDrives;
                                    ControllerStrDrvList = Controllerlist[key].DataDriveList
                                    TenantStrDrvtypelist = Controllerlist[key].TenantDriveList;
                                    if (ControllerStrDrvList.indexOf(x["@NodeDisk"]) === -1) {
                                        x["@NodeDisk"] = ControllerStrDrvList[0]
                                    }
                                    if (TenantStrDrvtypelist.indexOf(x["@TStorageDrive"]) === -1) {
                                        x["@TStorageDrive"] = TenantStrDrvtypelist[0]
                                    }
                                    ControllerOSDriveList = Controllerlist[key].OSDriveList
                                    if (ControllerOSDriveList.indexOf(x["@OSDisk"]) === -1) {
                                        x["@OSDisk"] = ControllerOSDriveList[0]
                                    }
                                    for (let proctype in Controllerlist[x["@Name"]].ProcessorList) {
                                        ControllerCPUFamilyList.push(proctype)
                                    }
                                    if (ControllerCPUFamilyList.indexOf(x["@ProcFamily"]) === -1) {
                                        x["@ProcFamily"] = ControllerCPUFamilyList[0]
                                    }
                                    ControllerCPUFamilytype = x["@ProcFamily"];
                                    for (let proctype in Controllerlist[x["@Name"]].ProcessorList) {
                                        if (proctype === x["@ProcFamily"]) {
                                            for (let proc in Controllerlist[x["@Name"]].ProcessorList[proctype]) {
                                                ControllerCPUList.push(proc)
                                            }
                                            if (ControllerCPUList.indexOf(x["@Proc"]) === -1) {
                                                x["@Proc"] = ControllerCPUList[0]
                                            }
                                            ControllerMemoryList = Controllerlist[x["@Name"]].ProcessorList[proctype][x["@Proc"]]
                                            if (ControllerMemoryList.indexOf(x["@Memory"]) === -1) {
                                                x["@Memory"] = ControllerMemoryList[0]
                                            }
                                        }
                                    }
                                }

                            }
                            if (x["@Name"].indexOf(Constants.MOONSHOT_510) > -1) {
                                if (x["@TStorageDriveQty"] == "0") {
                                    x["@StorageDiskQty"] = "2";
                                } else {
                                    x["@TStorageDriveQty"] = "1";
                                    x["@StorageDiskQty"] = "1";
                                }
                            } else {
                                x["@StorageDiskQty"] = "2";
                            }
                        }
                    }


                    if (textinput === "ControllerCPUtype")
                        x["@Proc"] = value;
                    if (textinput === "ControllerCPUFamilytype") {
                        x["@ProcFamily"] = value;
                        ControllerMemoryList = []
                        ControllerCPUList = []
                        for (let key in Controllerlist) {
                            if (key === x["@Name"]) {
                                for (let procfamily in Controllerlist[key].ProcessorList) {
                                    if (procfamily === x["@ProcFamily"]) {
                                        for (let proc in Controllerlist[key].ProcessorList[procfamily]) {
                                            ControllerCPUList.push(proc)
                                        }
                                        if (ControllerCPUList.indexOf(x["@Proc"]) === -1) {
                                            x["@Proc"] = ControllerCPUList[0]
                                        }
                                        ControllerMemoryList = Controllerlist[x["@Name"]].ProcessorList[procfamily][x["@Proc"]]
                                        if (ControllerMemoryList.indexOf(x["@Memory"]) === -1) {
                                            x["@Memory"] = ControllerMemoryList[0]
                                        }
                                    }
                                }

                            }

                        }
                    }



                    if (textinput === Constants.CONTROLLER_NODE_STORAGE_DRIVE) {
                        if (ControllerStrDrvtype !== value) {
                            let oldDrive = ControllerStrDrvtype;
                            x["@NodeDisk"] = value;
                            selectedDriveValidation(x["@TStorageDrive"], x["@OSDisk"], this.props.controllerdetails[x["@Name"]].MaxNVMeDrives, x["@Name"]);
                            if (!isValidDriveCombination) {
                                x["@NodeDisk"] = oldDrive;
                                ControllerDatadriveChanged = false;
                            }
                            ControllerStrDrvtype = x["@NodeDisk"];
                        }
                    }

                    if (textinput === Constants.CONTROLLER_TENANT_DRIVE) {
                        if (TenantStrDrvtype !== value) {
                            let oldDrive = TenantStrDrvtype;
                            x["@TStorageDrive"] = value;
                            selectedDriveValidation(x["@NodeDisk"], x["@OSDisk"], this.props.controllerdetails[x["@Name"]].MaxNVMeDrives, x["@Name"]);
                            if (!isValidDriveCombination) {
                                x["@TStorageDrive"] = oldDrive;
                            }
                            TenantStrDrvtype = x["@TStorageDrive"];
                        }
                    }


                    if (textinput === Constants.CONTROLLER_OSDRIVE) {
                        if (ControllerOSDrive !== value) {
                            let oldDrive = ControllerOSDrive;
                            x["@OSDisk"] = value;
                            selectedDriveValidation(x["@NodeDisk"], x["@TStorageDrive"], this.props.controllerdetails[x["@Name"]].MaxNVMeDrives, x["@Name"]);
                            if (!isValidDriveCombination) {
                                x["@OSDisk"] = oldDrive;
                            }
                            ControllerOSDrive = x["@OSDisk"];
                        }
                    }

                    if (textinput === "ControllerStrDrvCount") {

                        if (x["@NodeDisk"].toUpperCase().indexOf(NVMESTRING) !== -1 || (x["@Name"] === Constants.HPE_APOLLO_4200_GEN10 && (x["@NodeDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) > -1 || x["@NodeDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1))) {
                            ControllerNVMEMaxDrives = this.props.controllerdetails[x["@Name"]].MaxNVMeDrives;
                            if (value) {
                                let qty = ControllerNVMEMaxDrives;
                                if (x["@OSDisk"].toUpperCase().indexOf(NVMESTRING) !== -1 || (x["@Name"] === Constants.HPE_APOLLO_4200_GEN10 && (x["@OSDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) > -1 || x["@OSDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1))) {
                                    qty -= parseInt(x['@OSDiskQty'], 10);
                                }
                                if (x["@TStorageDrive"].toUpperCase().indexOf(NVMESTRING) !== -1 || (x["@Name"] === Constants.HPE_APOLLO_4200_GEN10 && (x["@TStorageDrive"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) > -1 || x["@TStorageDrive"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1))) {
                                    qty -= parseInt(x['@TStorageDriveQty'], 10);
                                }
                                if (parseInt(value, 10) < 2 && qty > 1) {
                                    value = "2";
                                }
                                if (parseInt(value, 10) < qty) {
                                    x["@StorageDiskQty"] = value;
                                } else x["@StorageDiskQty"] = qty.toString();
                            }
                            else x["@StorageDiskQty"] = value;
                        }

                        else {
                            ControllerMaxDrives = this.props.controllerdetails[x["@Name"]].MaxDrives;
                            if (chorBlr === Constants.BLUR) {
                                if (parseInt(value, 10) < 2) {
                                    value = "2"
                                }
                            }
                            if ((ControllerMaxDrives - parseInt(x["@TStorageDriveQty"], 10) - parseInt(x["@OSDiskQty"], 10)) < parseInt(value, 10)) {
                                x["@StorageDiskQty"] = (ControllerMaxDrives - parseInt(x["@TStorageDriveQty"], 10) - parseInt(x["@OSDiskQty"], 10)).toString()
                            } else {
                                x["@StorageDiskQty"] = value;
                            }
                        }
                    }

                    if (textinput === "TenantStrDrvCount") {
                        ControllerMaxDrives = this.props.controllerdetails[x["@Name"]].MaxDrives;
                        let nodeStorageDiskQty = parseInt(x["@StorageDiskQty"], 10);

                        if (x["@Name"] === Constants.HPE_APOLLO_4200_GEN10 && (x["@NodeDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) > -1 || x["@NodeDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1 || x["@NodeDisk"].toUpperCase().indexOf(Constants.NVME_) > -1)) {
                            if (x["@OSDisk"].indexOf(Constants.M_2) > -1) {
                                ControllerMaxDrives = 26;
                            } else {
                                ControllerMaxDrives = 24;
                            }
                            nodeStorageDiskQty = 0;
                        }
                        if ((ControllerMaxDrives - 2) < parseInt(value, 10)) {
                            x["@TStorageDriveQty"] = (ControllerMaxDrives - 2).toString()
                        }
                        if (ControllerMaxDrives - nodeStorageDiskQty - parseInt(x["@OSDiskQty"], 10) - parseInt(value, 10) < 0) {
                            value = (ControllerMaxDrives - nodeStorageDiskQty - parseInt(x["@OSDiskQty"], 10)).toString()
                        }
                        x["@TStorageDriveQty"] = value;
                    }

                    if (textinput === "ControllerCount") {
                        if (x["@HAIncluded"] === "true") {
                            if (parseInt(value, 10) < 3) {
                                x["@NodesCount"] = "3"
                            } else {
                                x["@NodesCount"] = value;
                            }
                        }
                        else {
                            x["@NodesCount"] = value;
                        }

                    }


                    if (textinput === "ControllerMemory")
                        x["@Memory"] = value;
                    break;
                case "Master":
                    if (textinput === "MasterHostType") {
                        if (MasterHostType !== value) {
                            x["@Name"] = value;
                            if (x["@Name"].indexOf(Constants.MOONSHOT_510) === -1 && x['@Name'].indexOf(Constants.E910) === -1 && x['@Name'].indexOf(Constants.MOONSHOT_750) === -1) {
                                x["@ServerName"] = x["@Name"]
                                x["@ProcQty"] = "2"
                            }
                            else {
                                x["@ServerName"] = "HP Moonshot System"
                                x["@ProcQty"] = "1"
                            }
                            x["@OSDiskQty"] = x["@Name"].indexOf(Constants.MOONSHOT_510) > -1 ? "1" : "2";
                            MasterCPUList = []
                            MasterMemoryList = []
                            MasterOSDriveList = []
                            MasterStrDrvList = []
                            MasterTenantStrDrvtypelist = [];
                            MasterCPUFamilyList = []
                            for (let key in Masterlist) {
                                if (key === x["@Name"]) {
                                    MasterMaxDrives = Masterlist[key].MaxDrives;
                                    MasterNVMEMaxDrives = Masterlist[key].MaxNVMeDrives;
                                    MasterStrDrvList = Masterlist[key].DataDriveList
                                    MasterTenantStrDrvtypelist = Masterlist[key].TenantDriveList;
                                    if (MasterStrDrvList.indexOf(x["@NodeDisk"]) === -1) {
                                        x["@NodeDisk"] = MasterStrDrvList[0]
                                    }
                                    if (MasterTenantStrDrvtypelist.indexOf(x["@TStorageDrive"]) === -1) {
                                        x["@TStorageDrive"] = MasterTenantStrDrvtypelist[0]
                                    }
                                    MasterOSDriveList = Masterlist[key].OSDriveList
                                    if (MasterOSDriveList.indexOf(x["@OSDisk"]) === -1) {
                                        x["@OSDisk"] = MasterOSDriveList[0]
                                    }
                                    for (let proctype in Masterlist[x["@Name"]].ProcessorList) {
                                        MasterCPUFamilyList.push(proctype)
                                    }
                                    if (MasterCPUFamilyList.indexOf(x["@ProcFamily"]) === -1) {
                                        x["@ProcFamily"] = MasterCPUFamilyList[0]
                                    }
                                    MasterCPUFamilytype = x["@ProcFamily"];
                                    for (let proctype in Masterlist[x["@Name"]].ProcessorList) {
                                        if (proctype === x["@ProcFamily"]) {
                                            for (let proc in Masterlist[x["@Name"]].ProcessorList[proctype]) {
                                                MasterCPUList.push(proc)
                                            }
                                            if (MasterCPUList.indexOf(x["@Proc"]) === -1) {
                                                x["@Proc"] = MasterCPUList[0]
                                            }
                                            MasterMemoryList = Masterlist[x["@Name"]].ProcessorList[proctype][x["@Proc"]]
                                            if (MasterMemoryList.indexOf(x["@Memory"]) === -1) {
                                                x["@Memory"] = MasterMemoryList[0]
                                            }
                                        }
                                    }
                                }

                            }
                            if (x["@Name"].indexOf(Constants.MOONSHOT_510) > -1) {
                                if (x["@TStorageDriveQty"] == "0") {
                                    x["@StorageDiskQty"] = "2";
                                } else {
                                    x["@TStorageDriveQty"] = "1";
                                    x["@StorageDiskQty"] = "1";
                                }
                            } else {
                                x["@StorageDiskQty"] = "2";
                            }
                        }
                    }


                    if (textinput === "MasterCPUtype")
                        x["@Proc"] = value;
                    if (textinput === "MasterCPUFamilytype") {
                        x["@ProcFamily"] = value;
                        MasterMemoryList = []
                        MasterCPUList = []
                        for (let key in Masterlist) {
                            if (key === x["@Name"]) {
                                for (let procfamily in Masterlist[key].ProcessorList) {
                                    if (procfamily === x["@ProcFamily"]) {
                                        for (let proc in Masterlist[key].ProcessorList[procfamily]) {
                                            MasterCPUList.push(proc)
                                        }
                                        if (MasterCPUList.indexOf(x["@Proc"]) === -1) {
                                            x["@Proc"] = MasterCPUList[0]
                                        }
                                        MasterMemoryList = Masterlist[x["@Name"]].ProcessorList[procfamily][x["@Proc"]]
                                        if (MasterMemoryList.indexOf(x["@Memory"]) === -1) {
                                            x["@Memory"] = MasterMemoryList[0]
                                        }
                                    }
                                }

                            }

                        }
                    }



                    if (textinput === Constants.MASTER_NODE_STORAGE_DRIVE) {
                        if (MasterStrDrvtype !== value) {
                            let oldDrive = MasterStrDrvtype;
                            x["@NodeDisk"] = value;
                            selectedDriveValidation(x["@TStorageDrive"], x["@OSDisk"], this.props.masterdetails[x["@Name"]].MaxNVMeDrives, x["@Name"]);
                            if (!isValidDriveCombination) {
                                x["@NodeDisk"] = oldDrive;
                                MasterDatadriveChanged = false;
                            }
                            MasterStrDrvtype = x["@NodeDisk"];
                        }
                    }

                    if (textinput === Constants.MASTER_TENANT_DRIVE) {
                        if (MasterTenantStrDrvtype !== value) {
                            let oldDrive = MasterTenantStrDrvtype;
                            x["@TStorageDrive"] = value;
                            selectedDriveValidation(x["@NodeDisk"], x["@OSDisk"], this.props.masterdetails[x["@Name"]].MaxNVMeDrives, x["@Name"]);
                            if (!isValidDriveCombination) {
                                x["@TStorageDrive"] = oldDrive;
                            }
                            MasterTenantStrDrvtype = x["@TStorageDrive"];
                        }
                    }


                    if (textinput === Constants.MASTER_OSDRIVE) {
                        if (MasterOSDrive !== value) {
                            let oldDrive = MasterOSDrive;
                            x["@OSDisk"] = value;
                            selectedDriveValidation(x["@NodeDisk"], x["@TStorageDrive"], this.props.masterdetails[x["@Name"]].MaxNVMeDrives, x["@Name"]);
                            if (!isValidDriveCombination) {
                                x["@OSDisk"] = oldDrive;
                            }
                            MasterOSDrive = x["@OSDisk"];
                        }
                    }

                    if (textinput === "MasterStrDrvCount") {

                        if (x["@NodeDisk"].toUpperCase().indexOf(NVMESTRING) !== -1 || (x["@Name"] === Constants.HPE_APOLLO_4200_GEN10 && (x["@NodeDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) > -1 || x["@NodeDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1))) {
                            MasterNVMEMaxDrives = this.props.masterdetails[x["@Name"]].MaxNVMeDrives;
                            if (value) {
                                let qty = MasterNVMEMaxDrives;
                                if (x["@OSDisk"].toUpperCase().indexOf(NVMESTRING) !== -1 || (x["@Name"] === Constants.HPE_APOLLO_4200_GEN10 && (x["@OSDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) > -1 || x["@OSDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1))) {
                                    qty -= parseInt(x['@OSDiskQty'], 10);
                                }
                                if (x["@TStorageDrive"].toUpperCase().indexOf(NVMESTRING) !== -1 || (x["@Name"] === Constants.HPE_APOLLO_4200_GEN10 && (x["@TStorageDrive"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) > -1 || x["@TStorageDrive"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1))) {
                                    qty -= parseInt(x['@TStorageDriveQty'], 10);
                                }
                                if (parseInt(value, 10) < 2 && qty > 1) {
                                    value = "2";
                                }
                                if (parseInt(value, 10) < qty) {
                                    x["@StorageDiskQty"] = value;
                                } else x["@StorageDiskQty"] = qty.toString();
                            }
                            else x["@StorageDiskQty"] = value;
                        }

                        else {
                            MasterMaxDrives = this.props.masterdetails[x["@Name"]].MaxDrives;
                            if (chorBlr === Constants.BLUR) {
                                if (parseInt(value, 10) < 2) {
                                    value = "2"
                                }
                            }
                            if ((MasterMaxDrives - parseInt(x["@TStorageDriveQty"], 10) - parseInt(x["@OSDiskQty"], 10)) < parseInt(value, 10)) {
                                x["@StorageDiskQty"] = (MasterMaxDrives - parseInt(x["@TStorageDriveQty"], 10) - parseInt(x["@OSDiskQty"], 10)).toString()
                            } else {
                                x["@StorageDiskQty"] = value;
                            }
                        }
                    }

                    if (textinput === "MasterTenantStrDrvCount") {
                        MasterMaxDrives = this.props.masterdetails[x["@Name"]].MaxDrives;
                        let nodeStorageDiskQty = parseInt(x["@StorageDiskQty"], 10);

                        if (x["@Name"] === Constants.HPE_APOLLO_4200_GEN10 && (x["@NodeDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) > -1 || x["@NodeDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1 || x["@NodeDisk"].toUpperCase().indexOf(Constants.NVME_) > -1)) {
                            if (x["@OSDisk"].indexOf(Constants.M_2) > -1) {
                                MasterMaxDrives = 26;
                            } else {
                                MasterMaxDrives = 24;
                            }
                            nodeStorageDiskQty = 0;
                        }
                        if ((MasterMaxDrives - 2) < parseInt(value, 10)) {
                            x["@TStorageDriveQty"] = (MasterMaxDrives - 2).toString()
                        }
                        if (MasterMaxDrives - nodeStorageDiskQty - parseInt(x["@OSDiskQty"], 10) - parseInt(value, 10) < 0) {
                            value = (MasterMaxDrives - nodeStorageDiskQty - parseInt(x["@OSDiskQty"], 10)).toString()
                        }
                        x["@TStorageDriveQty"] = value;
                    }

                    if (textinput === "MasterCount") {
                        if (x["@HAIncluded"] === "true") {
                            if (parseInt(value, 10) < 3) {
                                x["@NodesCount"] = "3"
                            } else {
                                x["@NodesCount"] = value;
                            }
                        }
                        else {
                            x["@NodesCount"] = value;
                        }

                    }


                    if (textinput === "MasterMemory")
                        x["@Memory"] = value;
                    break;

            }
        })
        if (this.props.controllerconfigChanged === false) {
            this.props.ContrlChanged(true)
        }
        if (GatewayDatadriveChanged) {
            GatewayDatadriveChanged = false
            var data = {
                "strServer": GatewayHostType,
                "strDataDisk": gatewaydatadisk,
                "strConfigType": "BlueData",
                "rolename": "Gateway"
            }
            this.props.GetOSDiskList(data);
        }
        if (ControllerDatadriveChanged) {
            ControllerDatadriveChanged = false
            var inputs = {
                "strServer": ControllerHostType,
                "strDataDisk": controllerdatadisk,
                "strConfigType": "BlueData",
                "rolename": "Controller"
            }
            this.props.GetOSDiskList(inputs);
            var tenantInputs = {
                "strServer": ControllerHostType,
                "strDataDisk": controllerdatadisk,
                "strConfigType": "BlueData",
                "rolename": "Controller",
                "localStorage": "Local Tenant"
            }
            this.props.getTenantStorageDriveList(tenantInputs);
        }
        if (MasterDatadriveChanged) {
            MasterDatadriveChanged = false
            var inputs = {
                "strServer": MasterHostType,
                "strDataDisk": masterdatadisk,
                "strConfigType": "BlueData",
                "rolename": "Master"
            }
            this.props.GetOSDiskList(inputs);
            var tenantInputs = {
                "strServer": MasterHostType,
                "strDataDisk": masterdatadisk,
                "strConfigType": "BlueData",
                "rolename": "Master",
                "localStorage": "Local Tenant"
            }
            this.props.getTenantStorageDriveList(tenantInputs);
        }
        this.setState({})
    }

    renderErrorPopup = (msg, heading) => {
        return <Layer style={{ zIndex: '500 !important' }}>
            <Box direction="row" margin="none" separator="bottom" style={{ padding: "none", backgroundColor: "#425563" }} >
                <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%', padding: "10px", color: "#fff" }}>
                    <Heading tag="h4" strong={true} style={{ marginBottom: '0px' }}>{heading}</Heading>
                </Box>
                <Box direction="row" style={{ marginTop: "10px", padding: "5px" }} margin="none" pad="none" align='start' alignContent="start" onClick={this.layerClose} >
                    <CloseIcon size='small' colorIndex="light-2" style={{ stroke: 'white' }} />
                </Box>
            </Box>
            <Box style={{ padding: "10px" }}>
                <Paragraph>{msg}</Paragraph>
            </Box>
        </Layer>
    }

    layerClose = () => {
        warningText = "";
        this.setState(
            {
                inValidDrive: false
            }
        );
    }

    onVMWareCheckBoxChange = () => {
        let controllerObject = this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_)
        if (controllerObject["@VMWare"] === Constants.tRUE_) {
            controllerObject["@VMWare"] = Constants.fALSE_;
            this.props.workload.UserInputs.Environments.Licenses.Nimble = Constants.fALSE_;
        } else {
            let generalPurposeSelected = false;
            let MLOpsSelected = false;
            if (this.props.workload.UserInputs.Environments.Environment.find(solution => solution["@SolutionType"] === Constants.GENERAL_PURPOSE)["@isSelected"] === Constants.yES_) {
                generalPurposeSelected = true;
            }
            if (this.props.workload.UserInputs.Environments.Environment.find(solution => solution["@SolutionType"] === Constants.MLOPS)["@isSelected"] === Constants.yES_) {
                MLOpsSelected = true;
            }
            if (generalPurposeSelected || MLOpsSelected) {
                this.props.workload.UserInputs.Environments.Licenses.Nimble = Constants.tRUE_;
            }
            controllerObject["@VMWare"] = Constants.tRUE_;
        }
        this.props.workload.UserInputs.Environments.VMWareUserChoice = controllerObject["@VMWare"];
        updateControllerHostCount(this.props.workload);

        const configMode = this.props.workload.UserInputs.Environments.Environment.find(solution => solution["@isCurrentTab"] === Constants.yES_).Templates.ServerDetails.Requirements["@ConfigBasedOn"];
        const controllerServer = this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_)["@Name"]
        const controllerPayload = {
            "strServer": controllerServer,
            "strHostType": Constants.CONTROLLER_HOST,
            "strConfigMode": configMode,
            "isControllerHostVMWareChecked": this.props.workload.UserInputs.Environments.VMWareUserChoice
        }
        this.props.ControllerRecommendations(controllerPayload);
        this.props.ServiceError.guiState.GandCAPICount = 1;
        this.props.ServiceError.guiState.updateManagementDetails = false;

        this.setState({});
    }

    onMasterVMWareCheckBoxChange = () => {
        let masterObject = this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.MASTER_)
        if (masterObject["@VMWare"] === Constants.tRUE_) {
            masterObject["@VMWare"] = Constants.fALSE_;
            this.props.workload.UserInputs.Environments.Licenses.Nimble = Constants.fALSE_;
        } else {
            let generalPurposeSelected = false;
            let MLOpsSelected = false;
            if (this.props.workload.UserInputs.Environments.Environment.find(solution => solution["@SolutionType"] === Constants.GENERAL_PURPOSE)["@isSelected"] === Constants.yES_) {
                generalPurposeSelected = true;
            }
            if (this.props.workload.UserInputs.Environments.Environment.find(solution => solution["@SolutionType"] === Constants.MLOPS)["@isSelected"] === Constants.yES_) {
                MLOpsSelected = true;
            }
            if (generalPurposeSelected || MLOpsSelected) {
                this.props.workload.UserInputs.Environments.Licenses.Nimble = Constants.tRUE_;
            }
            masterObject["@VMWare"] = Constants.tRUE_;
        }
        this.props.workload.UserInputs.Environments.MasterVMWareUserChoice = masterObject["@VMWare"];
        updateMasterHostCount(this.props.workload);

        const configMode = this.props.workload.UserInputs.Environments.Environment.find(solution => solution["@isCurrentTab"] === Constants.yES_).Templates.ServerDetails.Requirements["@ConfigBasedOn"];
        const masterServer = this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.MASTER_)["@Name"]
        const masterPayload = {
            "strServer": masterServer,
            "strHostType": Constants.MASTER_HOST,
            "strConfigMode": configMode,
            "isControllerHostVMWareChecked": this.props.workload.UserInputs.Environments.MasterVMWareUserChoice
        }
        this.props.MasterRecommendations(masterPayload);
        this.props.ServiceError.guiState.GandCAPICount = 1;
        this.props.ServiceError.guiState.updateManagementDetails = false;

        this.setState({});
    }

    onGatewayVMWareCheckBoxChange = () => {
        let gatewayObject = this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.GATEWAY_);
        if (gatewayObject["@VMWare"] === Constants.tRUE_) {
            gatewayObject["@VMWare"] = Constants.fALSE_;
        } else {
            gatewayObject["@VMWare"] = Constants.tRUE_;
        }
        this.props.workload.UserInputs.Environments.GatewayVMWareUserChoice = gatewayObject["@VMWare"];
        this.setState({});
    }

    handleTabChanges = (e) => {
        // this.setState({ currentTabActiveIndex: e });
        this.props.guiState.currentTabActiveIndex = e;
        this.setState({});
    }

    render() {
        GatewayHostlist = []
        GatewayCPUList = []
        GatewayCPUFamilyList = []
        GatewayStrDrvList = []
        GatewayOSDriveList = []
        GatewayMemoryList = []

        ControllerHostlist = []
        ControllerCPUList = []
        ControllerCPUFamilyList = []
        ControllerStrDrvList = []
        TenantStrDrvtypelist = []
        ControllerOSDriveList = []
        ControllerMemoryList = []

        MasterHostlist = []
        MasterCPUList = []
        MasterCPUFamilyList = []
        MasterStrDrvList = []
        MasterTenantStrDrvtypelist = []
        MasterOSDriveList = []
        MasterMemoryList = []
        var edit = ''
        let VMWareCheckBox = false;
        let gatewayVMWareCheckBox = false;
        let MasterVMWareCheckBox = false;
        const configurationType = this.props.workload.UserInputs.Environments.Environment.find(solution => solution["@isCurrentTab"] === Constants.yES_).Templates.ServerDetails.Requirements["@ConfigBasedOn"];
        if (this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_)['@Name'].indexOf(Constants.MOONSHOT_510) !== -1) {
            this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_)['@OSDiskQty'] = "1"
        }
        if (this.props.gatewaydetails !== null) {

            this.props.workload.UserInputs.Environments.ManagementHosts.Server.filter((x) => {
                switch (x["@Type"]) {
                    case "Gateway":
                        if (x["@Name"] === "HP Apollo 4200 Gen10 Server") {
                            x["@Name"] = "HPE Apollo 4200 Gen10 Server"
                        }
                        if (x["@Name"].indexOf(Constants.MOONSHOT_510) === -1 && x['@Name'].indexOf(Constants.E910) === -1 && x['@Name'].indexOf(Constants.MOONSHOT_750) === -1) {
                            x["@ServerName"] = x["@Name"]
                            x["@ProcQty"] = "2"
                        }
                        else {
                            x["@ServerName"] = "HP Moonshot System"
                            x["@ProcQty"] = "1"
                        }
                        GatewayHostType = x["@Name"];
                        GatewayCPUtype = x["@Proc"];
                        GatewayStrDrvtype = x["@NodeDisk"];
                        GatewayOSDrive = x["@OSDisk"];
                        GatewayStrDrvCount = x["@StorageDiskQty"];
                        GatewayMemory = x["@Memory"];
                        GatewayCount = x["@NodesCount"];
                        GatewayCPUFamilytype = x["@ProcFamily"];
                        if (x["@VMWare"] === Constants.tRUE_) {
                            gatewayVMWareCheckBox = true;
                        }
                        // HAIncluded = (/true/i).test(x["@HAIncluded"]);
                        break;
                    case "Controller":
                        if (x["@Name"] === "HP Apollo 4200 Gen10 Server") {
                            x["@Name"] = "HPE Apollo 4200 Gen10 Server"
                        }

                        ControllerHostType = x["@Name"];
                        ControllerCPUtype = x["@Proc"];
                        ControllerStrDrvtype = x["@NodeDisk"];
                        ControllerOSDrive = x["@OSDisk"];
                        ControllerStrDrvCount = x["@StorageDiskQty"];
                        ControllerMemory = x["@Memory"];
                        ControllerCount = x["@NodesCount"];
                        ControllerCPUFamilytype = x["@ProcFamily"];
                        TenantStrDrvtype = x["@TStorageDrive"]
                        if (TenantStrDrvtype !== "None") {
                            TenantStrDrvQty = x["@TStorageDriveQty"]
                            edit = false
                        } else {
                            TenantStrDrvQty = "0"
                            x["@TStorageDriveQty"] = "0"
                            edit = true
                        }
                        // if (this.props.workload.UserInputs.Environments.Environment.find(solution => solution["@SolutionType"] === Constants.CAAS_)["@isSelected"] === Constants.yES_) {
                        //     x["@VMWare"] = Constants.tRUE_;
                        // }
                        if (x["@VMWare"] === Constants.tRUE_) {
                            VMWareCheckBox = true;
                        }
                        break;
                    case "Master":
                        if (x["@Name"] === "HP Apollo 4200 Gen10 Server") {
                            x["@Name"] = "HPE Apollo 4200 Gen10 Server"
                        }

                        MasterHostType = x["@Name"];
                        MasterCPUtype = x["@Proc"];
                        MasterStrDrvtype = x["@NodeDisk"];
                        MasterOSDrive = x["@OSDisk"];
                        MasterStrDrvCount = x["@StorageDiskQty"];
                        MasterMemory = x["@Memory"];
                        MasterCount = x["@NodesCount"];
                        MasterCPUFamilytype = x["@ProcFamily"];
                        MasterTenantStrDrvtype = x["@TStorageDrive"]
                        if (MasterTenantStrDrvtype !== "None") {
                            MasterTenantStrDrvQty = x["@TStorageDriveQty"]
                            edit = false
                        } else {
                            MasterTenantStrDrvQty = "0"
                            x["@TStorageDriveQty"] = "0"
                            edit = true
                        }
                        // if (this.props.workload.UserInputs.Environments.Environment.find(solution => solution["@SolutionType"] === Constants.CAAS_)["@isSelected"] === Constants.yES_) {
                        //     x["@VMWare"] = Constants.tRUE_;
                        // }
                        if (x["@VMWare"] === Constants.tRUE_) {
                            MasterVMWareCheckBox = true;
                        }
                        break;
                }
            })
            Gatewaylist = this.props.gatewaydetails
            for (let key in Gatewaylist) {
                GatewayHostlist.push(key);
                if (key === GatewayHostType) {
                    MaxDrives = Gatewaylist[key].MaxDrives
                    NVMEMaxDrives = Gatewaylist[key].MaxNVMeDrives
                    GatewayStrDrvList = Gatewaylist[key].DataDriveList;
                    GatewayStrDrvList = filterOptions(GatewayStrDrvList, configurationType, Constants.MANAGEMENT_HOSTS, Constants.DISK_);
                    GatewayOSDriveList = Gatewaylist[key].OSDriveList
                    for (let proctype in Gatewaylist[GatewayHostType].ProcessorList) {
                        GatewayCPUFamilyList.push(proctype);
                    }
                    if (GatewayCPUFamilyList.indexOf(GatewayCPUFamilytype) === -1) {
                        GatewayCPUFamilytype = GatewayCPUFamilyList[0]
                        this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(x => x['@Type'] === Constants.GATEWAY_)["@ProcFamily"] = GatewayCPUFamilytype;
                    }

                    for (let proctype in Gatewaylist[GatewayHostType].ProcessorList) {
                        if (proctype === GatewayCPUFamilytype) {
                            for (let proc in Gatewaylist[GatewayHostType].ProcessorList[proctype]) {
                                GatewayCPUList.push(proc);
                            }
                            GatewayCPUList = filterOptions(GatewayCPUList, configurationType, Constants.MANAGEMENT_HOSTS, Constants.PROCESSOR_);
                            GatewayCPUtype = GatewayCPUList.indexOf(GatewayCPUtype) === -1 ? GatewayCPUList[0] : GatewayCPUtype;
                            this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(x => x['@Type'] === Constants.GATEWAY_)["@Proc"] = GatewayCPUtype;
                            for (let proc in Gatewaylist[GatewayHostType].ProcessorList[proctype]) {

                                if (proc === GatewayCPUtype) {
                                    GatewayMemoryList = Gatewaylist[GatewayHostType].ProcessorList[proctype][proc]
                                }
                            }

                        }
                    }
                    if (GatewayCPUList.filter(processor => processor.indexOf(GatewayCPUtype) > -1).length == 0) {
                        GatewayCPUtype = GatewayCPUList[0];
                    } else {
                        GatewayCPUtype = GatewayCPUList.filter(processor => processor.indexOf(GatewayCPUtype) > -1)[0];
                    }
                    this.props.workload.UserInputs.Environments.ManagementHosts.Server.filter(x => x["@Type"] === Constants.GATEWAY_)[0]["@Proc"] = GatewayCPUtype;
                    GatewayMemoryList = Gatewaylist[GatewayHostType].ProcessorList[GatewayCPUFamilytype][GatewayCPUtype];
                    GatewayMemoryList = filterOptions(GatewayMemoryList, configurationType, Constants.MANAGEMENT_HOSTS, Constants.MEMORY_);
                }

            }
            Controllerlist = this.props.controllerdetails
            for (let key in Controllerlist) {
                ControllerHostlist.push(key);
                if (key === ControllerHostType) {
                    ControllerMaxDrives = Controllerlist[key].MaxDrives,
                        ControllerNVMEMaxDrives = Controllerlist[key].MaxNVMeDrives,
                        ControllerStrDrvList = Controllerlist[key].DataDriveList;
                    ControllerStrDrvList = filterOptions(ControllerStrDrvList, configurationType, Constants.MANAGEMENT_HOSTS, Constants.DISK_);
                    TenantStrDrvtypelist = Controllerlist[key].TenantDriveList;
                    TenantStrDrvtypelist = filterOptions(TenantStrDrvtypelist, configurationType, Constants.MANAGEMENT_HOSTS, Constants.DISK_);
                    ControllerOSDriveList = Controllerlist[key].OSDriveList
                    for (let proctype in Controllerlist[ControllerHostType].ProcessorList) {
                        ControllerCPUFamilyList.push(proctype);
                        if (proctype === ControllerCPUFamilytype) {
                            for (let proc in Controllerlist[ControllerHostType].ProcessorList[proctype]) {
                                ControllerCPUList.push(proc);
                                if (proc === ControllerCPUtype) {
                                    ControllerMemoryList = Controllerlist[ControllerHostType].ProcessorList[proctype][proc]
                                }
                            }

                        }
                    }
                    ControllerCPUList = filterOptions(ControllerCPUList, configurationType, Constants.MANAGEMENT_HOSTS, Constants.PROCESSOR_);
                    if (ControllerCPUList.filter(processor => processor.indexOf(ControllerCPUtype) > -1).length == 0) {
                        ControllerCPUtype = ControllerCPUList[0];
                    }
                    else {
                        ControllerCPUtype = ControllerCPUList.filter(processor => processor.indexOf(ControllerCPUtype) > -1)[0];
                    }
                    this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(x => x['@Type'] === Constants.CONTROLLER_)["@Proc"] = ControllerCPUtype;
                    ControllerMemoryList = Controllerlist[ControllerHostType].ProcessorList[ControllerCPUFamilytype][ControllerCPUtype];
                }

            }

            Masterlist = this.props.masterdetails
            for (let key in Masterlist) {
                MasterHostlist.push(key);
                if (key === MasterHostType) {
                    MasterMaxDrives = Masterlist[key].MaxDrives,
                        MasterNVMEMaxDrives = Masterlist[key].MaxNVMeDrives,
                        MasterStrDrvList = Masterlist[key].DataDriveList;
                    MasterStrDrvList = filterOptions(MasterStrDrvList, configurationType, Constants.MANAGEMENT_HOSTS, Constants.DISK_);
                    MasterTenantStrDrvtypelist = Masterlist[key].TenantDriveList;
                    MasterTenantStrDrvtypelist = filterOptions(MasterTenantStrDrvtypelist, configurationType, Constants.MANAGEMENT_HOSTS, Constants.DISK_);
                    MasterOSDriveList = Masterlist[key].OSDriveList
                    for (let proctype in Masterlist[MasterHostType].ProcessorList) {
                        MasterCPUFamilyList.push(proctype);
                        if (proctype === MasterCPUFamilytype) {
                            for (let proc in Masterlist[MasterHostType].ProcessorList[proctype]) {
                                MasterCPUList.push(proc);
                                if (proc === MasterCPUtype) {
                                    MasterMemoryList = Masterlist[MasterHostType].ProcessorList[proctype][proc]
                                }
                            }

                        }
                    }
                    MasterCPUList = filterOptions(MasterCPUList, configurationType, Constants.MANAGEMENT_HOSTS, Constants.PROCESSOR_);
                    if (MasterCPUList.filter(processor => processor.indexOf(MasterCPUtype) > -1).length == 0) {
                        MasterCPUtype = MasterCPUList[0];
                    }
                    else {
                        MasterCPUtype = MasterCPUList.filter(processor => processor.indexOf(MasterCPUtype) > -1)[0];
                    }
                    this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(x => x['@Type'] === Constants.MASTER_)["@Proc"] = MasterCPUtype;
                    MasterMemoryList = Masterlist[MasterHostType].ProcessorList[MasterCPUFamilytype][MasterCPUtype];
                }

            }

            this.props.workload.UserInputs.Environments.ManagementHosts.Server.filter((x) => {
                switch (x["@Type"]) {
                    case "Gateway":
                        if (GatewayMemoryList.indexOf(GatewayMemory) === -1 && GatewayMemoryList.length > 0) {
                            GatewayMemory = GatewayMemoryList[0]
                            x["@Memory"] = GatewayMemory;
                        }
                        if (GatewayStrDrvList.indexOf(GatewayStrDrvtype) === -1 && GatewayStrDrvList.length > 0) {
                            GatewayStrDrvtype = GatewayStrDrvList[0]
                            x['@NodeDisk'] = GatewayStrDrvtype
                        }
                        if (GatewayOSDriveList.indexOf(GatewayOSDrive) === -1 && GatewayOSDriveList.length > 0) {
                            GatewayOSDrive = GatewayOSDriveList[0]
                            x['@OSDisk'] = GatewayOSDrive
                        }
                        if (GatewayCPUList.indexOf(GatewayCPUtype) === -1 && GatewayCPUList.length > 0) {
                            GatewayCPUtype = GatewayCPUList[0]
                            x['@Proc'] = GatewayCPUtype;
                        }
                        break;
                    case "Controller":
                        if (ControllerMemoryList && ControllerMemoryList.indexOf(ControllerMemory) === -1 && ControllerMemoryList.length > 0) {
                            ControllerMemory = ControllerMemoryList[0]
                            x["@Memory"] = ControllerMemory;
                        }
                        if (ControllerStrDrvList.indexOf(ControllerStrDrvtype) === -1 && ControllerStrDrvList.length > 0) {
                            ControllerStrDrvtype = ControllerStrDrvList[0]
                            x["@NodeDisk"] = ControllerStrDrvtype;
                        }
                        if (TenantStrDrvtypelist.indexOf(TenantStrDrvtype) === -1 && TenantStrDrvtypelist.length > 0) {
                            TenantStrDrvtype = TenantStrDrvtypelist[0];
                            x["@TStorageDrive"] = TenantStrDrvtype;
                        }
                        if (ControllerOSDriveList.indexOf(ControllerOSDrive) === -1 && ControllerOSDriveList.length > 0) {
                            ControllerOSDrive = ControllerOSDriveList[0]
                            x["@OSDisk"] = ControllerOSDrive;

                        }
                        if (ControllerCPUList.indexOf(ControllerCPUtype) === -1 && ControllerCPUList.length > 0) {
                            ControllerCPUtype = ControllerCPUList[0]
                            x["@Proc"] = ControllerCPUtype;


                            for (let key in Controllerlist) {
                                if (key === ControllerHostType) {
                                    for (let proctype in Controllerlist[ControllerHostType].ProcessorList) {
                                        if (proctype === ControllerCPUFamilytype) {
                                            for (let proc in Controllerlist[ControllerHostType].ProcessorList[proctype]) {
                                                if (proc === ControllerCPUtype) {
                                                    ControllerMemoryList = Controllerlist[ControllerHostType].ProcessorList[proctype][proc];
                                                    ControllerMemoryList = filterOptions(ControllerMemoryList, configurationType, Constants.MANAGEMENT_HOSTS, Constants.MEMORY_);
                                                    ControllerMemory = ControllerMemoryList[0]
                                                    x["@Memory"] = ControllerMemory;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        let nodeStorageDiskQty = parseInt(x["@StorageDiskQty"], 10);
                        if (x["@Name"] === Constants.HPE_APOLLO_4200_GEN10 && (x["@NodeDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) > -1 || x["@NodeDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1 || x["@NodeDisk"].toUpperCase().indexOf(Constants.NVME_) > -1)) {
                            if (x["@Name"].indexOf(Constants.MOONSHOT_510) === -1 && x["@Name"].indexOf(Constants.E910) === -1) {
                                nodeStorageDiskQty = 0;
                            }
                        }
                        if (nodeStorageDiskQty + parseInt(x["@TStorageDriveQty"], 10) + parseInt(x["@OSDiskQty"], 10) > ControllerMaxDrives) {
                            if (x["@Name"].indexOf('m510') === -1) {
                                x["@StorageDiskQty"] = "2";
                                ControllerStrDrvCount = "2";
                                if (x["@TStorageDriveQty"] !== 0) {
                                    x["@TStorageDriveQty"] = "2"
                                    TenantStrDrvQty = "2";
                                }
                            }
                            else {
                                if (x["@TStorageDriveQty"] === 0) {
                                    x["@StorageDiskQty"] = "2";
                                    ControllerStrDrvCount = "2";
                                }
                                else {
                                    x["@StorageDiskQty"] = "1";
                                    ControllerStrDrvCount = "1";
                                    x["@TStorageDriveQty"] = "1"
                                    TenantStrDrvQty = "1";
                                }
                            }
                        }
                        break;

                    case "Master":
                        if (MasterMemoryList && MasterMemoryList.indexOf(MasterMemory) === -1 && MasterMemoryList.length > 0) {
                            MasterMemory = MasterMemoryList[0]
                            x["@Memory"] = MasterMemory;
                        }
                        if (MasterStrDrvList.indexOf(MasterStrDrvtype) === -1 && MasterStrDrvList.length > 0) {
                            MasterStrDrvtype = MasterStrDrvList[0]
                            x["@NodeDisk"] = MasterStrDrvtype;
                        }
                        if (MasterTenantStrDrvtypelist.indexOf(MasterTenantStrDrvtype) === -1 && MasterTenantStrDrvtypelist.length > 0) {
                            MasterTenantStrDrvtype = MasterTenantStrDrvtypelist[0];
                            x["@TStorageDrive"] = MasterTenantStrDrvtype;
                        }
                        if (MasterOSDriveList.indexOf(MasterOSDrive) === -1 && MasterOSDriveList.length > 0) {
                            MasterOSDrive = MasterOSDriveList[0]
                            x["@OSDisk"] = MasterOSDrive;

                        }
                        if (MasterCPUList.indexOf(MasterCPUtype) === -1 && MasterCPUList.length > 0) {
                            MasterCPUtype = MasterCPUList[0]
                            x["@Proc"] = MasterCPUtype;


                            for (let key in Masterlist) {
                                if (key === MasterHostType) {
                                    for (let proctype in Masterlist[MasterHostType].ProcessorList) {
                                        if (proctype === MasterCPUFamilytype) {
                                            for (let proc in Masterlist[MasterHostType].ProcessorList[proctype]) {
                                                if (proc === MasterCPUtype) {
                                                    MasterMemoryList = Masterlist[MasterHostType].ProcessorList[proctype][proc];
                                                    MasterMemoryList = filterOptions(MasterMemoryList, configurationType, Constants.MANAGEMENT_HOSTS, Constants.MEMORY_);
                                                    MasterMemory = MasterMemoryList[0]
                                                    x["@Memory"] = MasterMemory;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        let nodeStorageDiskQty1 = parseInt(x["@StorageDiskQty"], 10);
                        if (x["@Name"] === Constants.HPE_APOLLO_4200_GEN10 && (x["@NodeDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) > -1 || x["@NodeDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1 || x["@NodeDisk"].toUpperCase().indexOf(Constants.NVME_) > -1)) {
                            if (x["@Name"].indexOf(Constants.MOONSHOT_510) === -1 && x["@Name"].indexOf(Constants.E910) === -1) {
                                nodeStorageDiskQty1 = 0;
                            }
                        }
                        if (nodeStorageDiskQty1 + parseInt(x["@TStorageDriveQty"], 10) + parseInt(x["@OSDiskQty"], 10) > MasterMaxDrives) {
                            if (x["@Name"].indexOf('m510') === -1) {
                                x["@StorageDiskQty"] = "2";
                                MasterStrDrvCount = "2";
                                if (x["@TStorageDriveQty"] !== 0) {
                                    x["@TStorageDriveQty"] = "2"
                                    TenantStrDrvQty = "2";
                                }
                            }
                            else {
                                if (x["@TStorageDriveQty"] === 0) {
                                    x["@StorageDiskQty"] = "2";
                                    MasterStrDrvCount = "2";
                                }
                                else {
                                    x["@StorageDiskQty"] = "1";
                                    MasterStrDrvCount = "1";
                                    x["@TStorageDriveQty"] = "1"
                                    TenantStrDrvQty = "1";
                                }
                            }
                        }
                }
            })

        }
        var Loadingdata = ''
        if (this.props.isLoading) {
            Loadingdata = <Layer style={{ zIndex: '500 !important' }}>
                <Box direction='row' style={{ padding: '40px', backgroundColor: "#425563" }} size='medium' pad={{ 'between': 'small' }}>
                    <Spinning size='small' style={{ color: "#fff" }} />
                    <Heading tag='h5' margin='none' style={{ color: "#fff" }}>Please wait fetching OS Drives.</Heading>
                </Box>
            </Layer>
        }
        if (TenantStrDrvtype === "None") {
            TenantStrDrvtypelist = []
        }
        if (MasterTenantStrDrvtype === "None") {
            MasterTenantStrDrvtypelist = []
        }
        let HostChangedLayer = ''
        if (HostChanged && !this.props.isLoading) {
            HostChanged = false

        }
        var currentSelectedIndex = this.props.guiState.currentTabActiveIndex || 0;
        return (

            <Box pad='small' margin='none' style={{ position: 'relative', width: '100%' }}>
                <Warning message={Constants.HPECP_WARNING_MESSAGE} isEnabled={!this.props.displayWarning} history={this.props.history} />
                <Article full={true} margin="none" pad={{ between: 'small' }} style={{ maxHeight: '95%' }} justify='between' >
                    <ReactTooltip place="right" multiline={true} />
                    {Loadingdata}
                    {warningText}
                    {HostChangedLayer}
                    <Tabs justify='start' onActive={(e) => this.handleTabChanges(e)} activeIndex={currentSelectedIndex}>
                        <Tab title="Gateway Hosts">
                            <Box margin='none' pad={{ between: 'small' }} separator="all" style={{ padding: '15px', marginBottom: '100px' }} >
                                <Box direction='row' margin='none' pad={{ between: 'small' }}  >
                                    <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}> Host type</Paragraph>
                                        <CircleInformationIcon data-tip='Select the server model to use as a Controller server.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                                        <Select id='DiskCapacity' value={GatewayHostType} options={GatewayHostlist} onChange={(e) => this.GPUChange(e, "GatewayHostType")} />
                                    </FormField>
                                    {GatewayCPUFamilytype === "NA" ? "" :
                                        <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Processor family</Paragraph>
                                            <CircleInformationIcon data-tip='Select the processor family desired.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                                            <Select id='DiskCapacity' value={GatewayCPUFamilytype} options={GatewayCPUFamilyList} onChange={(e) => this.GPUChange(e, "GatewayCPUFamilytype")} />
                                        </FormField>}
                                    <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Processor type</Paragraph>
                                        <CircleInformationIcon data-tip='Select the processor type based on the processor family requested.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                                        <Select id='DiskCapacity' value={GatewayCPUtype} options={GatewayCPUList} onChange={(e) => this.GPUChange(e, "GatewayCPUtype")} />
                                    </FormField>
                                </Box>
                                <Box direction='row' margin='none' pad={{ between: 'small' }} >
                                    <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Memory</Paragraph>
                                        <CircleInformationIcon data-tip='Select the amount of memory desired per server. ' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                                        <Select id='Compression' value={GatewayMemory} options={GatewayMemoryList} onChange={(e) => this.GPUChange(e, "GatewayMemory")} />
                                    </FormField>
                                    <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Storage Drive</Paragraph>
                                        <CircleInformationIcon data-tip='Select the local storage drive size desired.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} >
                                        <Select id='DiskCapacity'
                                            value={GatewayStrDrvtype} options={GatewayStrDrvList} onChange={(e) => this.GPUChange(e, "GatewayStrDrvtype")} />
                                    </FormField>
                                    <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Storage Drive Count</Paragraph>
                                        <CircleInformationIcon data-tip='Select the number of drives desired.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} >
                                        <TextInput id='DiskCapacity'
                                            value={GatewayStrDrvCount} onDOMChange={(e) => this.GPUtextchange(e, "GatewayStrDrvCount", "Change")} onBlur={(e) => this.GPUtextchange(e, "GatewayStrDrvCount", "Blur")} />
                                    </FormField>
                                </Box>
                                <Box direction='row' margin='none' pad={{ between: 'small' }}  >
                                    <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>OS Drive</Paragraph>
                                        <CircleInformationIcon data-tip='Select the operating system drive size desired.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} style={{ width: '33%' }} >
                                        <Select id='DiskCapacity'
                                            value={GatewayOSDrive} options={GatewayOSDriveList} onChange={(e) => this.GPUChange(e, "GatewayOSDrive")} />
                                    </FormField>

                                    <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}> Host Count</Paragraph>
                                        <CircleInformationIcon data-tip='Select the number of gateway hosts desired. Selecting HA on the HPE Ezmeral Runtime Enterprise Workload Requirements screen will set the minimum gateway hosts to 2.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} style={{ width: '33%' }} >
                                        <TextInput id='DiskCapacity'
                                            value={GatewayCount} onDOMChange={(e) => this.GPUtextchange(e, "GatewayCount", "Change")} onBlur={(e) => this.GPUtextchange(e, "GatewayCount", "Blur")} />
                                    </FormField>
                                </Box>
                                <Box style={{ width: '10%' }}>
                                    <CheckBox label={Constants.VMWARE} checked={gatewayVMWareCheckBox} onChange={() => { this.onGatewayVMWareCheckBoxChange() }} />
                                </Box>
                            </Box>
                        </Tab>
                        <Tab title="Controller Hosts">
                            <Box margin='none' pad={{ between: 'small' }} separator="all" style={{ padding: '15px' }} >
                                <Box direction='row' margin='none' pad={{ between: 'small' }}  >
                                    <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Host type</Paragraph>
                                        <CircleInformationIcon data-tip='Select the server model to use as a Controller server. ' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                                        <Select id='DiskCapacity' options={ControllerHostlist} value={ControllerHostType} onChange={(e) => this.GPUChange(e, "ControllerHostType")} />
                                    </FormField>
                                    {ControllerCPUFamilytype === "NA" ? '' :
                                        <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Processor family</Paragraph>
                                            <CircleInformationIcon data-tip='Select the processor family desired.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                                            <Select id='DiskCapacity' value={ControllerCPUFamilytype} options={ControllerCPUFamilyList} onChange={(e) => this.GPUChange(e, "ControllerCPUFamilytype")} />
                                        </FormField>
                                    }
                                    <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Processor type </Paragraph>
                                        <CircleInformationIcon data-tip='Select the processor type based on the processor family requested.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                                        <Select id='DiskCapacity' value={ControllerCPUtype} options={ControllerCPUList} onChange={(e) => this.GPUChange(e, "ControllerCPUtype")} />
                                    </FormField>
                                </Box>
                                <Box direction='row' margin='none' pad={{ between: 'small' }} >
                                    <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Memory</Paragraph>
                                        <CircleInformationIcon data-tip='Select the amount of memory desired per server. ' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                                        <Select id='Compression' value={ControllerMemory} options={ControllerMemoryList} onChange={(e) => this.GPUChange(e, "ControllerMemory")} />
                                    </FormField>
                                    <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Ephemeral Storage Drive</Paragraph>
                                        <CircleInformationIcon data-tip='Select the Ephemeral storage drive size desired.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} >
                                        <Select id='DiskCapacity'
                                            value={ControllerStrDrvtype} options={ControllerStrDrvList} onChange={(e) => this.GPUChange(e, "ControllerStrDrvtype")} />
                                    </FormField>
                                    <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Ephemeral Storage Drive Quantity</Paragraph>
                                        <CircleInformationIcon data-tip='Select the number of drives desired.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                                        <TextInput id='DiskCapacity'
                                            value={ControllerStrDrvCount} onDOMChange={(e) => this.GPUtextchange(e, "ControllerStrDrvCount", "Change")} onBlur={(e) => this.GPUtextchange(e, "ControllerStrDrvCount", "Blur")} />
                                    </FormField>
                                </Box>
                                <Box direction='row' margin='none' pad={{ between: 'small' }}  >
                                    <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>OS Drive</Paragraph>
                                        <CircleInformationIcon data-tip='Select the operating system drive size desired.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} >
                                        <Select id='DiskCapacity'
                                            value={ControllerOSDrive} options={ControllerOSDriveList} onChange={(e) => this.GPUChange(e, "ControllerOSDrive")} />
                                    </FormField>
                                    <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Persistent Storage Drive</Paragraph>
                                        <CircleInformationIcon data-tip='Select the Persistent drive size desired.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}  >
                                        <Select id='DiskCapacity'
                                            //options={TenantStrDrvtypelist} 
                                            value={TenantStrDrvtype} onChange={(e) => this.GPUChange(e, "TenantStrDrvtype")} />
                                    </FormField>
                                    <FormField className="DiskCapacityDetails" label='Persistent Drive Quantity'>
                                        <TextInput id='DiskCapacity'
                                            value={TenantStrDrvQty} disabled={edit} onDOMChange={(e) => this.GPUtextchange(e, "TenantStrDrvCount", "Change")} onBlur={(e) => this.GPUtextchange(e, "TenantStrDrvCount", "Blur")} />
                                    </FormField>
                                </Box>

                                <Box direction='row' margin='none' pad={{ between: 'small' }}  >
                                    <ReactTooltip place="right" multiline={true} />
                                    <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Host Count</Paragraph>
                                        <CircleInformationIcon data-tip='Select the number of controller hosts desired. Selecting HA on the HPE Ezmeral Runtime Enterprise Workload Requirements screen will set the minimum controller hosts to 3.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} style={{ width: '33%' }} >
                                        <TextInput id='DiskCapacity'
                                            value={ControllerCount} onDOMChange={(e) => this.GPUtextchange(e, "ControllerCount", "Change")} onBlur={(e) => this.GPUtextchange(e, "ControllerCount", "Blur")} />
                                    </FormField>
                                </Box>
                                <Box style={{ width: '10%' }}>
                                    <CheckBox label={Constants.VMWARE} checked={VMWareCheckBox} onChange={() => { this.onVMWareCheckBoxChange() }} />
                                </Box>
                            </Box>
                        </Tab>
                        <Tab title="Master Hosts">
                            <Box margin='none' pad={{ between: 'small' }} separator="all" style={{ padding: '15px' }} >
                                <Box direction='row' margin='none' pad={{ between: 'small' }}  >
                                    <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Host type</Paragraph>
                                        <CircleInformationIcon data-tip='Select the server model to use as a Controller server. ' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                                        <Select id='DiskCapacity' options={MasterHostlist} value={MasterHostType} onChange={(e) => this.GPUChange(e, "MasterHostType")} />
                                    </FormField>
                                    {MasterCPUFamilytype === "NA" ? '' :
                                        <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Processor family</Paragraph>
                                            <CircleInformationIcon data-tip='Select the processor family desired.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                                            <Select id='DiskCapacity' value={MasterCPUFamilytype} options={MasterCPUFamilyList} onChange={(e) => this.GPUChange(e, "MasterCPUFamilytype")} />
                                        </FormField>
                                    }
                                    <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Processor type </Paragraph>
                                        <CircleInformationIcon data-tip='Select the processor type based on the processor family requested.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                                        <Select id='DiskCapacity' value={MasterCPUtype} options={MasterCPUList} onChange={(e) => this.GPUChange(e, "MasterCPUtype")} />
                                    </FormField>
                                </Box>
                                <Box direction='row' margin='none' pad={{ between: 'small' }} >
                                    <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Memory</Paragraph>
                                        <CircleInformationIcon data-tip='Select the amount of memory desired per server. ' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                                        <Select id='Compression' value={MasterMemory} options={MasterMemoryList} onChange={(e) => this.GPUChange(e, "MasterMemory")} />
                                    </FormField>
                                    <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Ephemeral Storage Drive</Paragraph>
                                        <CircleInformationIcon data-tip='Select the Ephemeral storage drive size desired.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} >
                                        <Select id='DiskCapacity'
                                            value={MasterStrDrvtype} options={MasterStrDrvList} onChange={(e) => this.GPUChange(e, "MasterStrDrvtype")} />
                                    </FormField>
                                    <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Ephemeral Storage Drive Quantity</Paragraph>
                                        <CircleInformationIcon data-tip='Select the number of drives desired.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                                        <TextInput id='DiskCapacity'
                                            value={MasterStrDrvCount} onDOMChange={(e) => this.GPUtextchange(e, "MasterStrDrvCount", "Change")} onBlur={(e) => this.GPUtextchange(e, "MasterStrDrvCount", "Blur")} />
                                    </FormField>
                                </Box>
                                <Box direction='row' margin='none' pad={{ between: 'small' }}  >
                                    <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>OS Drive</Paragraph>
                                        <CircleInformationIcon data-tip='Select the operating system drive size desired.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} >
                                        <Select id='DiskCapacity'
                                            value={MasterOSDrive} options={MasterOSDriveList} onChange={(e) => this.GPUChange(e, "MasterOSDrive")} />
                                    </FormField>
                                    <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Persistent Storage Drive</Paragraph>
                                        <CircleInformationIcon data-tip='Select the Persistent drive size desired.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}  >
                                        <Select id='DiskCapacity'
                                            //options={TenantStrDrvtypelist} 
                                            value={MasterTenantStrDrvtype} onChange={(e) => this.GPUChange(e, "MasterTenantStrDrvtype")} />
                                    </FormField>
                                    <FormField className="DiskCapacityDetails" label='Persistent Drive Quantity'>
                                        <TextInput id='DiskCapacity'
                                            value={MasterTenantStrDrvQty} disabled={edit} onDOMChange={(e) => this.GPUtextchange(e, "MasterTenantStrDrvCount", "Change")} onBlur={(e) => this.GPUtextchange(e, "MasterTenantStrDrvCount", "Blur")} />
                                    </FormField>
                                </Box>

                                <Box direction='row' margin='none' pad={{ between: 'small' }}  >
                                    <ReactTooltip place="right" multiline={true} />
                                    <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Host Count</Paragraph>
                                        <CircleInformationIcon data-tip='Select the number of controller hosts desired. Selecting HA on the HPE Ezmeral Runtime Enterprise Workload Requirements screen will set the minimum controller hosts to 3.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} style={{ width: '33%' }} >
                                        <TextInput id='DiskCapacity'
                                            value={MasterCount} onDOMChange={(e) => this.GPUtextchange(e, "MasterCount", "Change")} onBlur={(e) => this.GPUtextchange(e, "ControllerCount", "Blur")} />
                                    </FormField>
                                </Box>
                                <Box style={{ width: '10%' }}>
                                    <CheckBox label={Constants.VMWARE} checked={MasterVMWareCheckBox} onChange={() => { this.onMasterVMWareCheckBoxChange() }} />
                                </Box>
                            </Box>
                        </Tab>
                    </Tabs>
                </Article>
            </Box>

        );

    }
}
const mapStateToProps = (state) => {
    return {
        workload: state.sizerWorkload.workload,
        activeSession: state.sessions.activeSession,
        gatewaydetails: state.sizerWorkload.Gatewaydetails,
        controllerdetails: state.sizerWorkload.Controllerdetails,
        masterdetails: state.sizerWorkload.Masterdetails,
        isLoading: state.sizerWorkload.isLoading,
        controllerconfigChanged: state.sizerWorkload.ControllerConfigChanged,
        ConfigButton: state.sizerWorkload.calbtn,
        changeGatewayServer: state.sizerWorkload.changeGateway,
        updateScreen: state.sizerWorkload.updateScreen,
        displayWarning: state.sizerWorkload.guiState.displayWarning,
        ServiceError: state.sizerWorkload,
        guiState: state.sizerWorkload.guiState,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        OnToggleSizeButton: (value) => { dispatch(toggleSizeButton(value)) },
        OnGatewaydltsfetch: (value) => {
            dispatch(fetchgatewaydlts(value));
        },
        GetOSDiskList: (value) => {
            dispatch(getosdisklistBlueData(value));
        },
        ContrlChanged: (value) => {
            dispatch(controllerchnaged(value));
        },
        changeGateway: (value) => { dispatch({ type: CHANGE_GATEWAY, payload: value }) },
        getTenantStorageDriveList: (value) => { dispatch(getTenantStorageDiskList(value)) },
        //      OnFetchDefaults:()=>{
        //     dispatch(fetchDefaults());
        //   },
        ControllerRecommendations: (value) => { dispatch(GetControllerRecommendations(value)) },
        MasterRecommendations: (value) => { dispatch(GetMasterRecommendations(value)) }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(DesignRequirements);



// WEBPACK FOOTER //
// ./src/SizerUI/SizerScreens/HostServerConfiguration.js